import { observer } from "mobx-react-lite";
import { Navigate } from "react-router";

import { useStores } from "@stores";

// const pulse = keyframes`
//   0%, 100% {
//     opacity: 1;
//   }
//   50% {
//     opacity: 0.5;
//   }
// `;

// const LoadingContainer = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   height: 100vh;
//   width: 100%;
//   background-color: #000;
// `;
//
// const LogoContainer = styled.div`
//   animation: ${pulse} 1.5s ease-in-out infinite;
// `;
//
// const EkidenLogo = styled.svg`
//   width: 120px;
//   height: 120px;
// `;

export const DefaultMarketRedirect = observer(() => {
  const { marketStore } = useStores();

  // If we have markets loaded, redirect to the first one
  if (marketStore.allMarkets.length > 0) {
    const firstMarket = marketStore.allMarkets[0];
    return <Navigate to={`/trades/${firstMarket.symbol}`} replace />;
  }

  // TODO: Re-enable loader when markets loading is fixed
  // While markets are loading, show Ekiden.fi logo with animation
  // return (
  //   <LoadingContainer>
  //     <LogoContainer>
  //       <EkidenLogo fill="none" viewBox="0 0 40 41" xmlns="http://www.w3.org/2000/svg">
  //         <rect fill="#000" height="40" rx="20" width="40" y=".5" />
  //         <rect height="37.444" rx="18.722" stroke="#E2FF04" width="37.444" x="1.277" y="1.778" />
  //         <path
  //           d="m10.76 22 1.26-3h1.47l.84-2h-4.9l-.84 2h1.47L8.8 22H6.84L6 24h5.88l.84-2zM20 21h-1.96l.42-1h1.47l.84-2H19.3l.42-1h-1.96l-.42 1h-1.47l-.84 2h1.47l-.42 1h-1.96l-.84 2h1.96l-.42 1h1.96l.42-1h1.96zm7.42-2.5h-4.9l.63-1.5h4.9zm.28.5h-5.88l-.63 1.5h2.94l-.21.5c-.232.552-.859 1-1.4 1h-1.96l-.84 2h1.96c1.624 0 3.504-1.343 4.2-3l.21-.5h.98zm-.28 3-1.794 1.938C29.52 24 32.32 22 34 18h-1.96c-1.26 3-2.66 4-4.62 4"
  //           fill="#E2FF04"
  //         />
  //         <path d="M30.22 20h-1.96l.84-2h1.96z" fill="#E2FF04" />
  //       </EkidenLogo>
  //     </LogoContainer>
  //   </LoadingContainer>
  // );

  // Temporary: If no markets are loaded, redirect to a generic trades page
  return <Navigate to="/trades/default" replace />;
});
